// TODO: Review AI Code for feature: Process Map - Entire file is AI-generated
import { useTranslation } from 'react-i18next';
import { Map, Pencil, RotateCcw, Save, X, ChevronUp, ChevronDown } from 'lucide-react';
import { Button } from '@bliks-io/ui';

interface ProcessMapHeaderProps {
  showKpis: boolean;
  isEditorMode: boolean;
  canEdit: boolean;
  hasCustomPositions: boolean;
  isSaving: boolean;
  onToggleKpis: () => void;
  onRequestResetLayout: () => void;
  onEditorDiscard: () => void;
  onEditorSave: () => void;
  onEnterEditorMode: () => void;
}

export function ProcessMapHeader({
  showKpis,
  isEditorMode,
  canEdit,
  hasCustomPositions,
  isSaving,
  onToggleKpis,
  onRequestResetLayout,
  onEditorDiscard,
  onEditorSave,
  onEnterEditorMode
}: ProcessMapHeaderProps) {
  const { t } = useTranslation();

  return (
    <div className="flex items-center justify-between shrink-0">
      <div className="flex items-center gap-2">
        <h1 className="text-2xl font-bold flex items-center gap-2">
          <Map className="w-6 h-6" />
          {t('processMap.title')}
        </h1>
        <Button
          variant="ghost"
          size="small"
          onClick={onToggleKpis}
          className="text-muted-foreground"
        >
          {showKpis ? <ChevronUp className="w-4 h-4" /> : <ChevronDown className="w-4 h-4" />}
        </Button>
      </div>
      <div className="flex items-center gap-2">
        {isEditorMode && (
          <>
            {hasCustomPositions && (
              <Button
                variant="outline"
                size="small"
                onClick={onRequestResetLayout}
                disabled={isSaving}
              >
                <RotateCcw className="w-4 h-4 mr-1" />
                {t('processMap.resetLayout')}
              </Button>
            )}
            <Button variant="outline" size="small" onClick={onEditorDiscard} disabled={isSaving}>
              <X className="w-4 h-4 mr-1" />
              {t('processMap.discardChanges')}
            </Button>
            <Button variant="primary" size="small" onClick={onEditorSave} loading={isSaving}>
              <Save className="w-4 h-4 mr-1" />
              {t('processMap.saveChanges')}
            </Button>
          </>
        )}
        {!isEditorMode && canEdit && (
          <Button variant="outline" size="small" onClick={onEnterEditorMode}>
            <Pencil className="w-4 h-4 mr-1" />
            {t('processMap.editorMode')}
          </Button>
        )}
      </div>
    </div>
  );
}
